// extracted by mini-css-extract-plugin
export default {"grpNoticeSync":"groupData_grpNoticeSync__Eqtk9","Cloudicon":"groupData_Cloudicon__Xgbg5","groupdata":"groupData_groupdata__20h7K","link":"groupData_link__IqjNk"};